module.exports = __webpack_public_path__ + "img/app1.7bbea507.png";